import type { ChipListItem } from "../chipsFilter";
import React from "react";
import classNames from "classnames";

type ChipProps = ChipListItem & {
  isSelected: boolean;
  onClick: (value: ChipListItem["value"], newIsSelected: boolean) => void;
  brandingColor: "cerise" | "navy" | "grey";
};

const Chip = ({
  isSelected,
  value,
  label,
  onClick,
  brandingColor,
}: ChipProps) => {
  const defaultStyles =
    "inline-block leading-[20px] text-[16px] duration-200 px-4 py-[6px] ease-in-out rounded-[100px] transition-[background-color,box-shadow,color,border-color]";
  const focusStyles =
    "focus:outline-none focus-visible::outline-none focus-visible:ring-2 focus-visible:ring focus-visible:ring-inset focus-visible:ring-cerise";

  const colourStyles = {
    cerise:
      "bg-[#F7D2DF] text-cerise hover:bg-opacity-[0.8] active:bg-opacity-[0.8]",
    navy: "bg-[#BDC8FC] text-pro-blue hover:bg-opacity-[0.8] active:bg-opacity-[0.8]",
    grey: "bg-[rgba(2,2,49,0.2)] text-black-rock hover:bg-opacity-[0.8] active:bg-opacity-[0.8] font-bold",
  }[brandingColor];

  return (
    <button
      role={"option"}
      type={"button"}
      aria-disabled={"false"}
      data-color={brandingColor}
      data-testid="filter"
      className={classNames(defaultStyles, focusStyles, {
        "bg-[#E6E6EB] text-mono-70 hover:bg-[#C6C6CC] active:bg-mono-20":
          !isSelected,
        [colourStyles]: isSelected,
      })}
      aria-selected={isSelected}
      onClick={() => onClick(value, !isSelected)}
    >
      <span className={"inline-flex items-center"}>
        {label}
        {isSelected && (
          <span className={"ml-[5px]"}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M5 10.1111L9 14L15 7"
                stroke="currentColor"
                strokeWidth="2"
              />
            </svg>
          </span>
        )}
      </span>
    </button>
  );
};

export default Chip;
